import { render, staticRenderFns } from "./procurement_party_contracted_projects.vue?vue&type=template&id=0e9a6388&scoped=true&"
import script from "./procurement_party_contracted_projects.vue?vue&type=script&lang=js&"
export * from "./procurement_party_contracted_projects.vue?vue&type=script&lang=js&"
import style0 from "./procurement_party_contracted_projects.vue?vue&type=style&index=0&id=0e9a6388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a6388",
  null
  
)

export default component.exports